import { render, staticRenderFns } from "./CreateRIDC.vue?vue&type=template&id=ce3ddbdc&scoped=true&"
import script from "./CreateRIDC.vue?vue&type=script&lang=ts&"
export * from "./CreateRIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3ddbdc",
  null
  
)

export default component.exports